import React, { useState } from 'react';

import FilledWhitePlus from '../../../components/icons/plus/FilledWhitePlus';
import { CreateStepDialog } from './create-step.dialog';

import styles from './create-step-indicator.module.scss';
type CreateStepIndicatorProps = {
  stageId: string;
};

export const CreateStepIndicator: React.FC<CreateStepIndicatorProps> = ({ stageId }) => {
  const [isAddStepDialog, setIsAddStepDialog] = useState(false);

  return (
    <>
      <div className={styles['line-container']} onClick={() => setIsAddStepDialog(true)}>
        <div className={styles['add-container']}>
          <div className={styles['add-step-underline']} />
          <div className={styles['add-step-container']}>
            <FilledWhitePlus />

            <div className={styles['add-step-text']}>Add a step</div>
          </div>
        </div>
      </div>

      {isAddStepDialog && (
        <CreateStepDialog stageId={stageId} onCancel={() => setIsAddStepDialog(false)} />
      )}
    </>
  );
};
